import { render } from "./AddEmployeeView.vue?vue&type=template&id=4c1c01bc&scoped=true"
import script from "./AddEmployeeView.vue?vue&type=script&lang=js"
export * from "./AddEmployeeView.vue?vue&type=script&lang=js"

import "./AddEmployeeView.vue?vue&type=style&index=0&id=4c1c01bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1c01bc"]])

export default __exports__